import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import type ItemVM from 'ab-viewModels/item/edit.viewModel';

import { VendorPackageTypeLabel } from '@acceligentllc/shared/enums/vendorPackageType';

import { SegmentLabel } from '@acceligentllc/storybook';

import Label from 'af-components/LockedValue/Label';

import styles from './styles.module.scss';

interface OwnProps {
	item: ItemVM;
}

type Props = OwnProps;

const VendorInfo: React.FC<Props> = (props: Props) => {
	const {
		item,
	} = props;

	return (
		<>
			<div className={styles.section}>
				<div className="m-b-m">
					<SegmentLabel
						label="Vendor Information"
						tooltip="Supplier details for this item — vendor name, part number, pricing, packaging, and reference URL. Searchable by Vendor Name or Part Number when adding to Orders; Vendor Price determines order cost."
					/>
				</div>
				<Row className="p-l-0">
					<Col md={8}>
						<Label className={styles.label} label={'Vendor'} />
						<div className={styles.value}>{item.vendor?.name ?? 'N/A'}</div>
					</Col>
					<Col md={8}>
						<Label className={styles.label} label={'Vendor Part Number'} />
						<div className={styles.value}>{item.vendor?.partNumber ?? 'N/A'}</div>
					</Col>
					<Col md={8}>
						<Label className={styles.label} label={'Vendor Price'} />
						<div className={styles.value}>${item.vendor?.price ?? 'N/A'}</div>
					</Col>
				</Row>
				<Row className="p-l-0">
					<Col md={8}>
						<Label className={styles.label} label={'Package Type'} />
						<div className={styles.value}>{item.vendor?.packageType ? VendorPackageTypeLabel[item.vendor.packageType] : 'N/A'}</div>
					</Col>
					<Col md={8}>
						<Label className={styles.label} label={'Package Quantity'} />
						<div className={styles.value}>{item.vendor?.packageQuantity ?? 'N/A'}</div>
					</Col>
					<Col md={8}>
						<Label className={styles.label} label={'Vendor URL'} />
						<div className={styles.value}>{item.vendor?.url ?? 'N/A'}</div>
					</Col>
				</Row>
				<Row className="p-l-0">
					<Col md={24}>
						<Label className={styles.label} label={'Notes'} />
						<div className={styles.value}>{item.vendor?.note ?? '-'}</div>
					</Col>
				</Row>
			</div>
		</>
	);
};

export default React.memo(VendorInfo);
